const constants = {
  LIGHT_GRAY: "#C3CFD9",
  GRAY: "#808F9D",
  DARK_GRAY: "#293845",
  GREEN: "#1AAE9E",
  DARK_GREEN: "#0E7D71",
  YELLOW: "#FBE192",
  DARK_YELLOW: "#F7C52B",
  ORANGE: "#E8833A",

  URL: "https://mock-api.driven.com.br/api/v5/cineflex",

  LOADING_GIF: "https://media.tenor.com/tEBoZu1ISJ8AAAAC/spinning-loading.gif",
};

export default constants;
